import { MarketingTagDto } from '../../../modelView/marketing/MarketingTagDto';
import React, { useEffect } from 'react';
import { Card, CardContent, CardHeader, Checkbox, Grid, Typography } from '@mui/material';
import { MarketingTagEnum } from '../../../api/graphql/generated/schema';
import { useTranslation } from 'react-i18next';
import { useGetMarketingTagsQuery } from '../../../api/graphql/generated/hooks';

const initState = {
  possibleMarketingTags: [
    MarketingTagDto.initPossible(MarketingTagEnum.Partner),
    MarketingTagDto.initPossible(MarketingTagEnum.TopOffer),
    MarketingTagDto.initPossible(MarketingTagEnum.MarketLowestPrice),
    MarketingTagDto.initPossible(MarketingTagEnum.Reserved),
  ],
  userMarketingTags: [],
};

export default function MarketingTagSection(props: {
  inStoreCard: boolean;
  appliedMarketingTags: Array<string>;
  handleAdd: Function;
  handleRemove: Function;
}) {
  const { t } = useTranslation();

  const { data, loading, error } = useGetMarketingTagsQuery({
    fetchPolicy: 'cache-and-network',
  });

  const [possibleMarketingTags, setPossbileMarketingTags] = React.useState<Array<MarketingTagDto>>(
    initState.possibleMarketingTags.filter((mt) => mt.id !== MarketingTagEnum.Reserved || props.inStoreCard),
  );
  const [userMarketingTags, setUserMarketingTags] = React.useState<Array<MarketingTagDto>>(initState.userMarketingTags);

  useEffect(() => {
    if (!loading && !error && data) {
      setPossbileMarketingTags((previousMarketingTags) => {
        const newTags = data.getMarketingTags.map((tag) => MarketingTagDto.initPossibleTag(tag));
        const combined = [...previousMarketingTags, ...newTags];
        const uniqueTags = Array.from(new Map(combined.map((tag) => [tag.id, tag])).values());
        return uniqueTags;
      });
    }
  }, [data, loading, error]);

  useEffect(() => {
    setUserMarketingTags(() => {
      const mmTags: Array<MarketingTagDto> = [];
      possibleMarketingTags.forEach((pmt) => {
        if (props.appliedMarketingTags && props.appliedMarketingTags.includes(pmt.id as MarketingTagEnum)) {
          mmTags.push(MarketingTagDto.initAppliedFromMarketingTag(pmt));
        } else {
          pmt.isApplied = false;
          mmTags.push(pmt);
        }
      });
      return mmTags;
    });
  }, [possibleMarketingTags, props.appliedMarketingTags]);

  const handleIsApplied = (marketingTag: MarketingTagDto) => {
    if (marketingTag.isApplied) {
      props.handleRemove(marketingTag.id);
    } else {
      props.handleAdd(marketingTag.id);
    }
  };

  const renderMarketingTag = (marketingTag: MarketingTagDto) => {
    return (
      <Grid
        item
        justifyContent={'space-between'}
        sm={12}
        md={3}
        id={'marketing-tag-grid-' + marketingTag.id}
      >
        <Typography
          variant={'body2'}
          id={'marketing-tag-typography-' + marketingTag.id}
        >
          <Checkbox
            checked={marketingTag.isApplied}
            onChange={() => handleIsApplied(marketingTag)}
            color={'primary'}
            id={'marketing-tag-checkbox-' + marketingTag.id}
          />
          {t('marketingTag.enum.values.' + marketingTag.id, { defaultValue: marketingTag.label || '' })}
        </Typography>
      </Grid>
    );
  };

  return (
    <Card variant='outlined'>
      <CardHeader title={'Marketingové tagy'} />
      <CardContent>
        <Grid
          container
          direction={'row'}
          sm={12}
          md={12}
        >
          {userMarketingTags.map((mt, index) => renderMarketingTag(mt))}
        </Grid>
      </CardContent>
    </Card>
  );
}
